import React, { useEffect } from 'react';
import styles from './index.less';
import first from '@/assets/imgs/refundExplain/first.png';
import first_explain from '@/assets/imgs/refundExplain/first_explain.png';
import first_explain_en from '@/assets/imgs/refundExplain/first_explain_en.png';
import two from '@/assets/imgs/refundExplain/two.png';
import two_explain from '@/assets/imgs/refundExplain/two_explain.png';
import two_explain_en from '@/assets/imgs/refundExplain/two_explain_en.png';
import three from '@/assets/imgs/refundExplain/three.png';
import three_explain from '@/assets/imgs/refundExplain/three_explain.png';
import three_explain_en from '@/assets/imgs/refundExplain/three_explain_en.png';
import four from '@/assets/imgs/refundExplain/four.png';
import four_explain from '@/assets/imgs/refundExplain/four_explain.png';
import four_explain_en from '@/assets/imgs/refundExplain/four_explain_en.png';
import {TLang, ReplaceText, getCookie} from '@/utils/lang';
import NavBar from '@/components/NavBar';

const RefundExplain = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const refundRuleExplain: any = JSON.parse(sessionStorage.getItem('refundRuleExplain') || '[]') || [];
  const df_lang = getCookie('df_lang');
  return (
    <div className={styles.refundExplain}>
      <NavBar isShowMenu showService={false} text={TLang('退票说明', 'home', false, false, null)} initColor="#333" targetColor="#333" targetBgColor="#FFF" opacity={1} />
      <div className={styles.refundExplain_title}>{TLang('退票规则', 'home', false, false, null)}</div>
      <h1>一、{TLang('影院规则', 'home', false, false, null)}</h1>
      <div className={styles.refundExplain_content}>
        {refundRuleExplain.map((item) => <p key={item}>{item}</p>)}
      </div>
      <h1>二、{TLang('东福规则', 'home', false, false, null)}</h1>
      <div className={styles.refundExplain_content}>
        <p>1.{TLang('个别特殊场次根据影院要求可能不支持退票。具体以下单页面说明为准。', 'home', false, false, null)}</p>
        <p>2.{TLang('电影开场前一定时间内且用户未取票的情况下可支持退票，退票将可能产生额外服务费，具体退票规则及收费标准以下单页面说明为准。原订单实际支付金额扣除退票服务费后，剩余金额将在退票成功后7个工作日内原路退回。', 'home', false, false, null)}</p>
        <p>3.{TLang('目前仅支持整笔订单退票，不支持单个座位退票。', 'home', false, false, null)}</p>
        <p>4.{TLang('如发现作弊行为，东方福利网有权取消您的退票资格。', 'home', false, false, null)}</p>
      </div>
      <div className={styles.refundExplain_title}>{TLang('退票流程', 'home', false, false, null)}</div>
      <div className={styles.refundExplain_second_title}>
        <img src={first} alt="" />
        {TLang('在“我的-我的订单”中找到要退的电影票订单', 'home', false, false, null)}
      </div>
      <div className={`${styles.refundExplain_second_image} ${styles.first_image}`}>
        <img className={`${df_lang == 'en-US'? styles.img_en : styles.img}`} src={df_lang == 'en-US' ? first_explain_en :first_explain} alt="" />
      </div>

      <div className={styles.refundExplain_second_title}>
        <img src={two} alt="" />
        {TLang('进入电影票详情，点击底部的“申请退票”按钮', 'home', false, false, null)}
      </div>
      <div className={`${styles.refundExplain_second_image} ${styles.second_image}`}>
        <img className={`${df_lang == 'en-US'? styles.img_en : styles.img}`} src={df_lang == 'en-US' ? two_explain_en : two_explain} alt="" />
      </div>

      <div className={styles.refundExplain_second_title}>
        <img src={three} alt="" />
        {TLang('确认退款金额，点击“提交”退票申请按钮', 'home', false, false, null)}
      </div>
      <div className={`${styles.refundExplain_second_image} ${styles.three_image}`}>
        <img className={`${df_lang == 'en-US'? styles.img_en : styles.img}`} src={df_lang == 'en-US' ? three_explain_en : three_explain} alt="" />
      </div>

      <div className={styles.refundExplain_second_title}>
        <img src={four} alt="" />
        {TLang('提交成功后，可在电影订单详情页查看退票进度', 'home', false, false, null)}
      </div>
      <div className={`${styles.refundExplain_second_image} ${styles.four_image}`}>
        <img className={`${df_lang == 'en-US'? styles.img_en : styles.img}`} src={df_lang == 'en-US' ? four_explain_en : four_explain} alt="" />
      </div>
    </div>
  );
};

export default RefundExplain;
